import { ENDPOINTS, HOSTS } from "@/constants";
import {
  ADD_BEXRAPPORT,
  ADD_BEXRAPPORT_FAILURE,
  ADD_BEXRAPPORT_SUCCESS,
  DELETE_BEXRAPPORT,
  DELETE_BEXRAPPORT_FAILURE,
  DELETE_BEXRAPPORT_SUCCESS,
  LOAD_BEXRAPPORT,
  LOAD_BEXRAPPORT_FAILURE,
  LOAD_BEXRAPPORT_SUCCESS,
  LOAD_BEXRAPPORTS,
  LOAD_BEXRAPPORTS_FAILURE,
  LOAD_BEXRAPPORTS_SUCCESS,
  UPDATE_BEXRAPPORT,
  UPDATE_BEXRAPPORT_FAILURE,
  UPDATE_BEXRAPPORT_SUCCESS,
} from "./mutations";
import type { ActionTree } from "vuex";
import type { RootState } from "@/types";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import type { Bexrapport } from "@/types/bexSupport";
import type { BexrapportState } from "@/types/store";

export const actions: ActionTree<BexrapportState, RootState> = {
  fetchBexrapports({ commit }, params: any) {
    commit(LOAD_BEXRAPPORTS);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.BEXRAPPORTS}`, { params }).then(
      (response: AxiosResponse<Bexrapport[]>) => {
        commit(LOAD_BEXRAPPORTS_SUCCESS, response);
      },
      (error) => {
        commit(LOAD_BEXRAPPORTS_FAILURE, error.message);
      },
    );
  },
  addBexrapport({ commit }, bexrapport: any) {
    return new Promise((resolve, reject) => {
      commit(ADD_BEXRAPPORT);
      httpClient
        .post(`${HOSTS.AWS}/${ENDPOINTS.BEXRAPPORTS}`, {
          ...bexrapport,
        })
        .then(
          (response: AxiosResponse<any>) => {
            commit(ADD_BEXRAPPORT_SUCCESS, response.data);
            resolve(response.data);
          },
          (error) => {
            commit(ADD_BEXRAPPORT_FAILURE, error.message);
            reject(error);
          },
        );
    });
  },
  updateBexrapport({ commit }, bexrapport: any) {
    commit(UPDATE_BEXRAPPORT);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.BEXRAPPORTS}/${bexrapport.id}`, bexrapport)
      .then(
        (response: AxiosResponse<any>) => {
          commit(UPDATE_BEXRAPPORT_SUCCESS, response.data);
        },
        (error) => {
          commit(UPDATE_BEXRAPPORT_FAILURE, error.message);
        },
      );
  },

  // LOAD_ONE_BEXRAPPORT
  fetchBexrapport({ commit }, id: any) {
    commit(LOAD_BEXRAPPORT);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.BEXRAPPORTS}/${id}`).then(
      (response: AxiosResponse<any>) => {
        commit(LOAD_BEXRAPPORT_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_BEXRAPPORT_FAILURE, error.message);
      },
    );
  },

  deleteRapport({ commit }, repportId: any) {
    commit(DELETE_BEXRAPPORT);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.BEXRAPPORTS}/${repportId}`)
      .then(
        () => {
          commit(DELETE_BEXRAPPORT_SUCCESS, repportId);
        },
        (error) => {
          commit(DELETE_BEXRAPPORT_FAILURE, error.message);
        },
      );
  },
};
